const CloseIconBig = ({ size = 20 }: { size?: number }) => {
  return (
    <svg height={size} viewBox='0 0 20 20' width={size} xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M 15 5.9 L 14.1 5 L 10 9.1 L 5.9 5 L 5 5.9 L 9.1 10 L 5 14.1 L 5.9 15 L 10 10.9 L 14.1 15 L 15 14.1 L 10.9 10 L 15 5.9 Z'
        fillRule='evenodd'
        stroke='none'
      />
    </svg>
  );
};

export default CloseIconBig;
